export default __webpack_public_path__ + "static/media/project15.93d5c894.png";